import { createSlice } from '@reduxjs/toolkit';
import { DEFAULT_USER, IS_DEMO } from 'config.js';

const initialState = {
  isLogin: IS_DEMO,
  currentUser: IS_DEMO ? DEFAULT_USER : {},
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCurrentUser(state, action) {
      state.currentUser = action.payload;
    },
    setIsLoginUser(state, action) {
      state.isLogin = action.payload;
    },
  },
});

export const { setCurrentUser, setIsLoginUser } = authSlice.actions;
const authReducer = authSlice.reducer;

export default authReducer;
